import React from "react";
import PropTypes from "prop-types";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { OfficeWrapper } from "./styles";

const OfficeLocation = (props) => {
	const { officeLocations } = props;
	console.log(officeLocations);
	return (
		<OfficeWrapper
			officeLocations={officeLocations}
			className="contentContainer"
		>
			<h2>Our Offices</h2>
			<div className="locationContainer">
				<section className="sanLocation">
					<div className="addressBox">
						<h3>{officeLocations[0].location}</h3>
						<div className="addressContainer">
							<p className="addressTitle ft-18px">Our office address</p>
							<p className="addressLine ft-18px">
								{officeLocations[0].firstAddressLine}
							</p>
							<p className="addressLine ft-18px">
								{officeLocations[0].secondAddressLine}
							</p>
						</div>
						<CloudinaryImage
							url={officeLocations[0].mascotImage.image}
							lazyload
							altText="SF mascot"
						></CloudinaryImage>
					</div>
				</section>
				<section className="bangaloreLocation">
					<div className="addressBox">
						<h3>{officeLocations[1].location}</h3>
						<div className="addressContainer">
							<p className="addressTitle ft-18px">Our office address</p>
							<p className="addressLine ft-18px">
								{officeLocations[1].firstAddressLine}
							</p>
							<p className="addressLine ft-18px">
								{officeLocations[1].secondAddressLine}
							</p>
						</div>
						<CloudinaryImage
							url={officeLocations[1].mascotImage.image}
							lazyload
							altText="Bangalore Mascot"
						></CloudinaryImage>
					</div>
				</section>
			</div>
		</OfficeWrapper>
	);
};

OfficeLocation.propTypes = {
	officeLocations: PropTypes.array.isRequired,
};

OfficeLocation.defaultProps = {
	officeLocations: [],
};

export default OfficeLocation;
